(() => {
  const enhanceSlider = (slider) => {
    if (slider.dataset.fxEnhanced === 'true') return;

    slider.dataset.fxEnhanced = 'true';
    const track = slider.querySelector('[data-autoplay]');
    const counter = slider.querySelector('.slider-counter--current');
    const autoplayButton = slider.querySelector('.slideshow__autoplay');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateCounter = (event) => {
      const currentPage = event?.detail?.currentPage || 1;
      if (counter) counter.textContent = String(currentPage).padStart(2, '0');
    };

    const syncMotion = () => {
      if (!track || track.dataset.autoplay !== 'true') return;

      if (reducedMotion.matches) {
        slider.pause();
        if (autoplayButton) {
          autoplayButton.classList.add('slideshow__autoplay--paused');
          autoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        }
        return;
      }

      if (slider.autoplayButtonIsSetToPlay !== false) slider.play();
    };

    slider.addEventListener('slideChanged', updateCounter);
    reducedMotion.addEventListener('change', syncMotion);
    if (autoplayButton) {
      autoplayButton.addEventListener('click', () => {
        if (reducedMotion.matches) window.setTimeout(() => slider.pause(), 0);
      });
    }

    updateCounter();
    syncMotion();
  };

  const enhanceAll = (root = document) => {
    root.querySelectorAll('.fx-hero-slider').forEach(enhanceSlider);
  };

  customElements.whenDefined('slideshow-component').then(() => enhanceAll());
  document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));
})();
